import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import Card from '@mui/material/Card';
import { styled, darken } from '@mui/material/styles';
import * as React from 'react';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import WidgetGraph from '../../Widget-Graph/Widget-Graph';
import WidgetSearch from '../../Widget-Search/Widget-Search';
import { Box, Chip, Grid, IconButton, Popover, Stack, Theme, Typography, Badge, MenuItem, Menu, CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import { getAgentDrawerDeets, getAgentEvents, getAgentList, getAgentStateDetail, getWidgetConfig } from '../../../services/api-service';
import '../AgentList/AgentList.css';
import BargeInDrawer from '../../BargeInDrawer/BargeInDrawer';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AgentDetailsDrawer from '../../AgentDetailsDrawer/AgentDetailsDrawer';
import { ReactComponent as DragIcon } from '../../../static/icons/drag.svg';
import { STATUS_CLASS_MAP, WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import { AccessTime } from '@mui/icons-material';
import { checkRoles, mapRowDataWithThreshold, secondsToMinSec, secondsToTime, checkDataAccessFilters, determineFilterType, getLengthOfProps, checkSettings, filterRowsBySearch, getUpdatedFilterType, getColumnId, getLevelColor } from '../../../utils/util';
import AgentListVTable from './AgentListVTable';
import SelectPopover from '../../SelectPopover/SelectPopover';
import { KeyboardArrowDownOutlined as KeyboardArrowDownOutlinedIcon } from '@mui/icons-material';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import useTableSort from '../../../hooks/useTableSort';

interface Column {
	id:
	| 'AgentName'
	| 'agentAction'
	| 'CampaignNameOfLastCall'
	| 'CallFrom_SkillName'
	| 'AgentMode'
	| 'CustomerPhoneNumber'
	| 'CallType'
	| 'hamburger'
	| 'Skill'
	| 'LastCall'
	| 'AgentState'
	| 'Since'
	| 'Details'
	| 'SkillsFormatted'
	| 'GroupsFormatted'
	| 'HoldStatus'
	| 'AgentId'
	| 'HoldDuration'
	| 'AgentPhoneNumber'
	| 'sip_location'
	| 'CallStatus';
	label: string;
	minWidth?: number;
	draggable?: boolean;
	width?: number;
	align?: 'right' | 'center' | 'left';
	type?: string;
}

const useStyles: any = makeStyles((theme: Theme) => ({
	popoverContent: {
		minWidth: 350,
		fontSize: '12px',
		lineHeight: 2
	},
	dragdropItemsWrapper: {
		display: 'flex',
		height: '100%',
		width: '100%',
		margin: '0 1rem',
		alignItems: 'center'
	},
	dropdownSearchContainer: {
		height: '30px',
		border: '1px solid #D6D6D7',
		borderRadius: '8px',
		backgroundColor: '#F2F2F2'
	},
	searchContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#FFFFFF',
		height: '28px',
		borderLeft: '1px solid #D6D6D7',
		borderRadius: '0px 8px 8px 0px',
		width: '193px',
		padding: '0px 8px'
	},
	searchInput: {
		border: 'none',
		outline: 'none'
	},
	dropdownLabelMenuItem: {
		fontWeight: '400 !important',
		fontSize: '12px !important',
		lineHeight: '14px !important',
		color: '#212121 !important',
		width: '149px'
	},
	dropdownMenu: {
		minWidth: 'fit-content !important',
		border: '1px solid #e6e5e6 !important',
		boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04) !important',
		borderRadius: '12px !important',
		marginTop: '10px !important'
	},
	dropdownMenuItem: {
		fontWeight: '400 !important',
		fontSize: '12px !important',
		lineHeight: '14px !important',
		color: '#212121 !important'
	},
}));

const DetailsIconButton = styled(IconButton)(
	({ theme }) => `
  background-color: ${theme.palette.primary.main};
	color: white;
	padding: 0.1rem;

  :hover {
    background-color: ${darken(theme.palette.primary.main, 0.2)};
  }
`
);

const thresholdItemsDefault = [
	// {
	// 	label: 'Idle',
	// 	key: 'AgentState',
	// 	value: 'IDLE',
	// 	fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	// },
	{
		label: 'Ready',
		key: 'AgentState',
		value: 'READY',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	},
	{
		label: 'Busy',
		key: 'AgentState',
		value: 'BUSY',
		fields: [
			{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
			{ label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
		]
	},
	{
		label: 'ACW',
		key: 'AgentState',
		value: 'ACW',
		fields: [
			{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
			{ label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
		]
	},
	{
		label: 'Pause',
		key: 'AgentState',
		value: 'PAUSED',
		fields: [
			{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
			{ label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
		]
	},
	// {
	// 	label: 'Calling',
	// 	key: 'AgentState',
	// 	value: 'CALLING' || 'Calling',
	// 	fields: [
	// 		{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
	// 		{ label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
	// 	]
	// },
	{
		label: 'AUX',
		key: 'AgentState',
		value: 'AUX',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	}
];

const defaultColumns: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110, width: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120, width: 120 },
	{ id: 'agentAction', label: '', minWidth: 30, width: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
		minWidth: 120,
		width: 120
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
		minWidth: 50,
		width: 50
	},
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
		width: 120
	},
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 120, width: 120, type: 'TIME' },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'sip_location', label: 'SIP Location', align: 'center', minWidth: 50, width: 120 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, align: 'center', minWidth: 100, width: 100 },
	{ id: 'SkillsFormatted', label: 'Skills', align: 'left', minWidth: 100, width: 100, draggable: true },
	{ id: 'CallStatus', label: 'Last Call', align: 'left', minWidth: 50, width: 100 },
	{ id: 'AgentState', label: 'State', draggable: true, align: 'center', minWidth: 50, width: 100 },
	{ id: 'Since', label: 'Duration', align: 'center', minWidth: 30, width: 100, type: 'TIME' },
	{ id: 'Details', label: 'Details', align: 'center', minWidth: 30, width: 100 },

	// { id: 'holdTime', label: 'Hold Time', minWidth: 65 },
	// { id: 'AgentState', label: 'Status', minWidth: 50 },
	// { id: 'Since', label: 'Duration', minWidth: 50 },
	// { id: 'adminAction', label: 'Admin Action', minWidth: 185 },
	{ id: 'hamburger', label: '', minWidth: 20 },
];

const columnsWithoutDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110, width: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120, width: 120 },
	{ id: 'agentAction', label: '', minWidth: 30, width: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
		minWidth: 120,
		width: 120
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
		minWidth: 50,
		width: 50
	},
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
		width: 120
	},
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, draggable: true },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 120, width: 120, type: 'TIME' },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'sip_location', label: 'SIP Location', align: 'center', minWidth: 50, width: 120 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, align: 'center', minWidth: 100, width: 100 },
	{ id: 'SkillsFormatted', label: 'Skills', align: 'left', minWidth: 100, width: 100, draggable: true },
	{ id: 'CallStatus', label: 'Last Call', align: 'left', minWidth: 50, width: 100 },
	{ id: 'AgentState', label: 'State', draggable: true, align: 'center', minWidth: 50, width: 100 },
	{ id: 'Since', label: 'Duration', align: 'center', minWidth: 30, width: 100, type: 'TIME' },
	{ id: 'Details', label: 'Details', align: 'center', minWidth: 30, width: 100 },

	// { id: 'holdTime', label: 'Hold Time', minWidth: 65 },
	// { id: 'AgentState', label: 'Status', minWidth: 50 },
	// { id: 'Since', label: 'Duration', minWidth: 50 },
	// { id: 'adminAction', label: 'Admin Action', minWidth: 185 },
	{ id: 'hamburger', label: '', minWidth: 20 },
];

const columnsWithDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110, width: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120, width: 120 },
	{ id: 'agentAction', label: '', minWidth: 30, width: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
		minWidth: 120,
		width: 120
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
		minWidth: 50,
		width: 50
	},
	{ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left', draggable: true },
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
		width: 50
	},
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, width: 120, draggable: true },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, width: 120, type: 'TIME' },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', align: 'center', minWidth: 50, width: 100 },
	{ id: 'sip_location', label: 'SIP Location', align: 'center', minWidth: 50, width: 120 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, align: 'center', minWidth: 30, width: 100 },
	{ id: 'SkillsFormatted', label: 'Skills', align: 'left', minWidth: 100, width: 100, draggable: true },
	{ id: 'CallStatus', label: 'Last Call', align: 'left', minWidth: 50, width: 100 },
	{ id: 'AgentState', label: 'State', draggable: true, align: 'center', minWidth: 50, width: 100 },
	{ id: 'Since', label: 'Duration', align: 'center', minWidth: 30, width: 100, type: 'TIME' },
	{ id: 'Details', label: 'Details', align: 'center', minWidth: 30, width: 100 },
	{ id: 'hamburger', label: '', minWidth: 20 }
];

const defaultDownloadColumns: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 120, width: 120 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120, width: 120 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
		minWidth: 120,
		width: 150
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
		minWidth: 120,
		width: 150
	},
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
		width: 120
	},
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, draggable: true },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, width: 120, type: 'TIME' },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'sip_location', label: 'SIP Location', align: 'center', minWidth: 50, width: 120 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, align: 'center', minWidth: 30, width: 120 },
	{ id: 'SkillsFormatted', label: 'Skills', align: 'left', minWidth: 290, width: 120, draggable: true },
	{ id: 'CallStatus', label: 'Last Call', align: 'left', minWidth: 50, width: 120 },
	{ id: 'AgentState', label: 'State', draggable: true, align: 'center', minWidth: 50, width: 120 },
	{ id: 'Since', label: 'Duration', align: 'center', minWidth: 30, width: 120, type: 'TIME' },
];

const downloadColumnsWithDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 120, width: 120 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120, width: 120 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
		minWidth: 120,
		width: 150
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
		minWidth: 120,
		width: 150
	},
	{ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left', draggable: true },
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
		width: 120
	},
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, width: 120, draggable: true },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, width: 120, type: 'TIME' },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', align: 'center', minWidth: 50, width: 120 },
	{ id: 'sip_location', label: 'SIP Location', align: 'center', minWidth: 50, width: 120 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, align: 'center', minWidth: 30, width: 120 },
	{ id: 'SkillsFormatted', label: 'Skills', align: 'left', minWidth: 290, width: 120, draggable: true },
	{ id: 'CallStatus', label: 'Last Call', align: 'left', minWidth: 50, width: 120 },
	{ id: 'AgentState', label: 'State', draggable: true, align: 'center', minWidth: 50, width: 120 },
	{ id: 'Since', label: 'Duration', align: 'center', minWidth: 30, width: 120, type: 'TIME' },
];


export default function AgentList(props: any) {
	const fullscreenContainer = props?.fullscreenContainer || null;
	const { useState, useRef } = React;
	const classes = useStyles();
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columns, setColumns] = useState<any>(defaultColumns);
	const [downloadColumns, setDownloadColumns] = useState<Array<any>>(defaultDownloadColumns);
	const [filteredRowData, setFilteredRowData] = useState<Array<any>>([]);
	const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
	const [isBargeInOpen, setIsBargeInOpen] = useState<boolean>(false);
	const [isAgentDetailsDrawerOpen, setIsAgentDetailsDrawerOpen] = useState<boolean>(false);
	const [eleRefPoint, setElRefPoint] = useState<any>(null);
	const [selectedAgent, setSelectedAgent] = useState<any>(null);
	const [allowedFilters, setAllowedFilters] = useState<string[]>(['Campaign', 'Skill', 'Group', 'CampaignType']);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || (checkDataAccessFilters() ? 3 : 1));
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [agentListFilter, setAgentListFilter] = useState<any>(props?.selectedFilters?.filters || []);
	const [groupingColumns, setGroupingColumns] = useState<any>(props?.widgetData?.groupingColumns || []);
	const [groupedData, setGroupedData] = useState<any>({});
	const downloadContent = useRef<null | any>(null);
	const [responseLength, setresponseLength] = useState<Number>(0);
	const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
	const [selectedAgentEventDetails, setSelectedAgentEventDetails] = useState<any>(null);
	const [isEventsPopoverOpen, setIsEventsPopoverOpen] = useState<boolean>(false);
	const [thresholdItems, setThresholdItems] = useState<Array<any>>(thresholdItemsDefault);
	const [drawerDetails, setDrawerDetails] = useState<any>({});
	const [searchText, setSearchText] = useState<any>({});
	const searchTextRef = useRef('');
	const [searchTextForAgentID, setSearchTextForAgentID] = useState<any>({});
	const tableContainerRef = useRef(null);
	const tableDataRef = useRef(null);
	const [resized, setResized] = useState<any>(false)
	const [moreData, setMoreData] = useState<any>(false);
	const [isColumnsPopoverOpen, setIsColumnsPopoverOpen] = useState<boolean>(false);
	const [columnsEleRefPoint, setColumnsElRefPoint] = useState<any>(null);
	const [searchFieldMenuAnchorEl, setSearchFieldMenuAnchorEl] = useState<any>(null);
	const labelOpen = Boolean(searchFieldMenuAnchorEl);
	const [searchSelect, setSearchSelect] = useState<any>({ name: 'Agent Name', key: 'AgentName' });
	const searchKeyRef = useRef('');
	const [selectedColumns, setSelectedColumns] = useState<any>(props?.selectedFilters?.filterHeaders?.data || columns);
	const [savedThresholdList, setSavedThresholdList] = useState<any>({
		thresholdList: props?.selectedThresholds?.thresholdList?.length ? props?.selectedThresholds?.thresholdList : [],
		showSkillList: props?.selectedThresholds?.showSkillList || false
	});
	const { sortData, handleSort, getSortIcon, getSortedGroupData, sortGroupedData } = useTableSort({});

	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const getAgentIncId = (agent: any) => agent?.AgentIncId ?? agent?.AgentUniqueId ?? '';

	const intervalRef = useRef<any>(null);
	const loadingRef = useRef<boolean>(false);
	const isRealTimeSkillUpdateRef = useRef<boolean>(false);;

	const prevAdditionalFilters = React.useMemo(() => {
		if (props?.selectedFilters?.extraParams) {
			try {
				return (JSON.parse(props.selectedFilters.extraParams));
			}
			catch (err) {
				console.error("Error parsing extraParams", err);
				return { state: [], mode: [] }
			}
		}
		return { state: [], mode: [] }
	}, [props?.selectedFilters?.extraParams]);

	const [additionalFilters, setAdditionalFilters] = useState<any>(prevAdditionalFilters);

	const additionalFiltersLength = React.useMemo(() => {
		let count = 0;
		if (additionalFilters?.state?.length) {
			count += additionalFilters.state.length;
		}
		if (additionalFilters?.mode?.length) {
			count += additionalFilters.mode.length;
		}
		return count;
	}, [additionalFilters]);

	React.useEffect(() => {
		if (savedThresholdList && savedThresholdList.thresholdList && savedThresholdList.thresholdList.length) {
			console.log('thresholdItems savedThresholdList useEffect', savedThresholdList);
			setThresholdItems(savedThresholdList.thresholdList);
		}
	}, [savedThresholdList.thresholdList]);

	React.useEffect(() => {
		const resizeObserver = new ResizeObserver((entries) => {
			if (entries && entries.length > 0) {
				const newHeight: any = entries[0].target.clientHeight;
				if (parseInt(newHeight) > 488) {
					setResized(true)
				}
				if (parseInt(newHeight) === 408) {
					setResized(false)
				}
				if (parseInt(newHeight) === 618) {
					setResized(false)
				}
			}
		});

		const resizeDataObserver = new ResizeObserver((entries) => {
			if (entries && entries.length > 0) {
				const Height: any = entries[0].target.clientHeight;
				if (parseInt(Height) > 280) {
					setMoreData(true)
				}
			}
		});

		if (tableContainerRef.current) {
			resizeObserver.observe(tableContainerRef.current);
		};

		if (tableDataRef.current) {
			resizeDataObserver.observe(tableDataRef.current);
		};

		return () => {
			resizeObserver.disconnect();
			resizeDataObserver.disconnect()
		};
	}, []);

	React.useEffect(() => {
		const filterHeaders = props?.selectedFilters?.filterHeaders?.data;
		const dataAccessEnabled = checkRoles("ROLE_DATA_ACCESS");
		if (dataAccessEnabled) {
			setColumns(columnsWithDataAccess);
			setDownloadColumns(downloadColumnsWithDataAccess);
		}
		else {
			setColumns(columnsWithoutDataAccess);
			setDownloadColumns(defaultDownloadColumns);
		}
		if (filterHeaders && Array.isArray(filterHeaders)) {
			const currColumns = (dataAccessEnabled ? columnsWithDataAccess : defaultColumns);
			const filteredColumns = filterHeaders?.filter((column) => currColumns?.filter((col) => col.id == column.id));
			setSelectedColumns(filteredColumns);
		}
	}, []);

	React.useEffect(() => {
		const fetchWidgetConfig = async () => {
			try {
				if (checkDataAccessFilters()) {
					let widgetConfig = await getWidgetConfig('104', 'widget');
					if (widgetConfig) {
						if (typeof widgetConfig === 'string') {
							widgetConfig = JSON.parse(widgetConfig);
						}
						// Check the condition and set the appropriate filters
						const filters = widgetConfig.data && checkDataAccessFilters()
							? widgetConfig.data
							: widgetConfig.config;

						if (filters) {
							const filtersArray = filters.split(',');
							setAllowedFilters(filtersArray);
							const determinedFilterType = determineFilterType(filtersArray);
							if (determinedFilterType !== undefined) {
								setFilterType(determinedFilterType);
							}
						}
					}
				}
			} catch (error) {
				console.error('Error fetching widget config:', error);
			}
		};
		fetchWidgetConfig();
	}, []);

	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: '#F0F1F2',
			color: '#000000',
			padding: '10px 16px'
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
			padding: '10px 16px'
		}
	}));
	const agentDetailsItems = [
		{ label: 'Total Login', key: 'TotalLoginDuration', type: true },
		{ label: 'Last Logout', key: 'LastLogoutTime' },
		{ label: 'Calls Offered', key: 'TotalCalls' },
		{ label: 'Answered', key: 'AnsweredCalls' },
		{ label: 'Abandoned', key: 'AbandonedCalls' },
		{ label: 'Average Hold Time', key: 'AverageHoldDuration', type: true },
		{ label: 'AHT', key: 'AverageHandlingDuration', type: true },
		{ label: 'ASA', key: 'AverageSpeedToAnswer', type: true },
		{ label: 'ACW', key: 'TotalWrapupDuration', type: true },
		{ label: 'Pause Time', key: 'TotalPauseDuration', type: true }
	];
	const getPopoverContent = () => {
		return (
			<Box sx={{ p: 2 }} className={classes.popoverContent}>
				<div>
					{agentDetailsItems.map((item: any, idx: number) => (
						<Grid key={idx} container direction="row" justifyContent="space-between" alignItems="center">
							<Grid item xs={7}>
								<b>{item.label}</b>
							</Grid>

							{item.type ? <span>{secondsToTime(selectedAgent?.[item.key]) || 0}</span> : <span>{selectedAgent?.[item.key] || 0}</span>}
						</Grid>
					))}
				</div>
			</Box>
		);
	};

	async function agentListRealTimeSkillUpdate() {
		try {
			const resp = await checkSettings("AG_REAL_TIME_SKL_UPD");
			if (resp && (resp === true || resp === "true")) {
				isRealTimeSkillUpdateRef.current = true;
			} else {
				isRealTimeSkillUpdateRef.current = false;
			}
		} catch (error) {
			console.log("Error in agentListRealTimeSkillUpdate", error);
		}
	}

	React.useEffect(() => {
		try {
			if (checkRoles("ROLE_DATA_ACCESS")) {
				agentListRealTimeSkillUpdate();
			}
		} catch (error) {
			console.log("Error in agentListRealTimeSkillUpdate", error);
		}
	}, []);

	const handleOnColumnsPopoverClose = () => {
		setColumnsElRefPoint(null);
		setIsColumnsPopoverOpen(false);
	};

	const handleOnSelectColumnChange = (selected: any) => {

		let selectedIds: string[] = []
		let orderedSelected = [];

		selected.map((selected: any) => {
			selectedIds.push(selected.id)
		})

		if (selectedIds.includes("AgentId")) {
			orderedSelected.push({ id: 'AgentId', label: 'Agent Id', minWidth: 120 })
		}
		if (selectedIds.includes("AgentName")) {
			orderedSelected.push({ id: 'AgentName', label: 'Agent Name', minWidth: 80 })
		}
		if (selectedIds.includes("agentAction")) {
			orderedSelected.push({ id: 'agentAction', label: '', minWidth: 30 })
		}
		if (selectedIds.includes("CampaignNameOfLastCall")) {
			orderedSelected.push({ id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true })
		}
		if (selectedIds.includes("CallFrom_SkillName")) {
			orderedSelected.push({ id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true })
		}
		if (selectedIds.includes("CallType")) {
			orderedSelected.push({ id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 })
		}
		if (selectedIds.includes("AgentPhoneNumber")) {
			orderedSelected.push({ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 })
		}
		if (selectedIds.includes("sip_location")) {
			orderedSelected.push({ id: 'sip_location', label: 'SIP Location', minWidth: 50 })
		}
		if (selectedIds.includes("SkillsFormatted")) {
			orderedSelected.push({ id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("GroupsFormatted")) {
			orderedSelected.push({ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("CustomerPhoneNumber")) {
			orderedSelected.push({ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 })
		}
		if (selectedIds.includes("AgentMode")) {
			orderedSelected.push({ id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 })
		}
		if (selectedIds.includes("HoldStatus")) {
			orderedSelected.push({ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("HoldDuration")) {
			orderedSelected.push({ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' })
		}
		if (selectedIds.includes("AgentState")) {
			orderedSelected.push({ id: 'AgentState', label: 'State', draggable: true, minWidth: 50 })
		}
		if (selectedIds.includes("CallStatus")) {
			orderedSelected.push({ id: 'CallStatus', label: 'Last Call Status', minWidth: 50 })
		}
		if (selectedIds.includes("Since")) {
			orderedSelected.push({ id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' })
		}
		if (selectedIds.includes("adminAction")) {
			orderedSelected.push({ id: 'adminAction', label: 'Admin Action', minWidth: 185 })
		}
		if (selectedIds.includes("Details")) {
			orderedSelected.push({ id: 'Details', label: 'Details', minWidth: 30 })
		}
		if (selectedIds.includes("hamburger")) {
			orderedSelected.push({ id: 'hamburger', label: '', minWidth: 20 })
		}
		props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: orderedSelected });
		setSelectedColumns(orderedSelected);
		handleOnColumnsPopoverClose();
	};

	const onHamburgerClick = (event: any) => {
		setColumnsElRefPoint({ top: event.clientY, left: event.clientX });
		setIsColumnsPopoverOpen(true);
	};

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		'&:nth-of-type(even)': {
			backgroundColor: '#edf0f280'
		},
		// hide last border
		'&:last-child td, &:last-child th': {
			border: 0
		}
	}));
	const handleOnPopoverClose = () => {
		setElRefPoint(null);
		setSelectedAgent(null);
		setIsPopoverOpen(false);
	};
	const handleDownload = (type: string) => {
		console.log(type);
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const getTableData = async (filters = '0') => {
		try {
			if (loadingRef.current) return;
			loadingRef.current = true;
			let state = additionalFilters?.state?.length > 0 ? additionalFilters.state.join(',') : 'All';
			let mode = additionalFilters?.mode?.length > 0 ? additionalFilters.mode.join(',') : 'All';
			let data = await getAgentList({
				filters, type: getUpdatedFilterType(filterType, 'string'), state, mode, apiId: (isRealTimeSkillUpdateRef.current) ? 504 : 104
			});
			const updatedRowData = mapRowDataWithThreshold(thresholdItems, data);
			for (const row of updatedRowData) {
				const skills = row.AgentSkills?.split(',') || [];
				const groups = row.AgentGroups?.split(',') || [];
				const tempSkills = [...skills];
				const tempGroups = [...groups];
				if (groups.length > 1) {
					row.GroupsFormatted = (
						<div>
							{groups.slice(0, 1).join(',')}
							<span key="badge" className="badge" title={tempGroups.join(',')}>
								{`+${groups.length - 1}`}
							</span>
						</div>
					);
				}
				else {
					row.GroupsFormatted = groups.join(',');
				}
				if (skills.length > 1) {
					row.SkillsFormatted = (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div style={{ display: 'inline-block', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
								{skills.slice(0, 1).join(',')}
							</div>
							<span key="badge" className="badge" title={tempSkills.join(',')}>
								{`+${skills.length - 1}`}
							</span>
						</div>
					);
				} else {
					row.SkillsFormatted = skills.join(',');
				}
				if (row && row.PauseReason) {
					row.AgentState = row.PauseReason
				}
				if (checkRoles('ROLE_CHAT_CALL') && row && row?.SessionCount && parseInt(row.SessionCount) > 0) {
					row.AgentState = "BUSY";
				}
				row.HoldStatus = 'Non-Hold';
				if (row && typeof row === "object" && row?.HoldDuration && "HoldDuration" in row && row.HoldDuration && (typeof row.HoldDuration === "number" || !isNaN(Number(row.HoldDuration)))) {
					row.HoldStatus = row.HoldDuration > 0 ? 'Hold' : 'Non-Hold';
				}
			}
			setRowData(updatedRowData);
			let filteredRows: any = [];
			const currentSearchText = searchTextRef?.current || '';
			if (currentSearchText?.length) {
				filteredRows = filterRowsBySearch({ rows: updatedRowData, searchKey: searchKeyRef.current, searchText: currentSearchText });
				// const filteredRows = updatedRowData.filter((item: any) => item.AgentName.toLowerCase().includes(searchText));
				setFilteredRowData(filteredRows);
			} else {
				setFilteredRowData(updatedRowData);
			}
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		} catch (error) {
			console.error("Failed to fetch agent list", error);
		} finally {
			loadingRef.current = false;
		}
	};

	const agentDetails = async (event: any, agent: any) => {
		const agentData = await getAgentStateDetail({ agentId: getAgentIncId(agent) });
		setSelectedAgent(agentData.find((eachAgent) => eachAgent));
		setElRefPoint({ top: event.clientY, left: event.clientX });
		setIsPopoverOpen(true);
	};

	// const agentStates = (agent: any) => {
	// 	console.log(agent);
	// };

	const agentEvents = async (event: any, agent: any) => {
		setSelectedAgent(agent);
		let response = await getAgentEvents({ agentId: getAgentIncId(agent) });
		response = response.map((dataItem) => ({
			...dataItem,
			StartTime: dataItem.StartTime ? `${dataItem.StartTime.toString().split(' ')[0]}T${dataItem.StartTime.toString().split(' ')[1]}` : '',
			EndTime: dataItem.EndTime ? `${dataItem.EndTime.split(' ')[0]}T${dataItem.EndTime.toString().split(' ')[1]}` : ''
		}));
		setSelectedAgentEventDetails(response);
		setElRefPoint({ top: event.clientY, left: event.clientX });
		setIsEventsPopoverOpen(true);
	};

	const toggleBargeInDrawer = () => {
		setIsBargeInOpen(!isBargeInOpen);
	};

	const agentDetailsDrawer = async (agent: any) => {
		const data = await getAgentDrawerDeets({ filters: '0', type: filterType, agentId: getAgentIncId(agent) });
		setDrawerDetails(data);
		setSelectedAgent(agent);
		toggleAgentDetailsDrawer();
	};

	const toggleAgentDetailsDrawer = () => {
		setIsAgentDetailsDrawerOpen(!isAgentDetailsDrawerOpen);
	};

	const handleFilterDelete = (id: Number) => {
		const newFilter = agentListFilter.filter((item: any) => item.id !== id);
		setAgentListFilter(newFilter);
		props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
	};

	const handleFilterExistingData = (filteredData: any) => {
		setAgentListFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
	};

	const clearFilter = () => {
		console.info('Clear all filter.');
		setAgentListFilter([]);
		setAdditionalFilters({ state: [], mode: [] });
		props?.handleFilterChange?.([], filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify({ state: [], mode: [] }), '', '', false, { data: selectedColumns });
	};

	const handleDragStart = (event: React.DragEvent<HTMLDivElement>, item: any) => {
		event.dataTransfer?.setData('agentData', JSON.stringify(item));
	};

	function saveDataToDashboard(key: string, data: any) {
		if (props && props?.handleSaveDataToFilter) {
			props?.handleSaveDataToFilter({
				widgetId: props?.widgetId,
				value: {
					[key]: data
				}
			})
		}
	}

	const handleOnDrop = (event: React.DragEvent<HTMLDivElement>) => {
		const agentData: any = JSON.parse(event.dataTransfer?.getData('agentData') || '{}');
		if (!groupingColumns.find((col: any) => col.id === agentData.id)) {
			let grpCol = [...groupingColumns, agentData];
			setGroupingColumns(grpCol);
			saveDataToDashboard('groupingColumns', grpCol);
		}
		return;
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection, additionalFilters }: any) => {
		console.log("here full ata ", selectedFilters);
		setAgentListFilter(selectedFilters);
		setFilterType(newFilterType);
		setFilterSection(newfilterSection);
		setAdditionalFilters(additionalFilters);
		props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
		toggleDrawer(false);
	};

	React.useEffect(() => {
		const filterIds = (agentListFilter.length && !(responseLength === agentListFilter.length)) ? agentListFilter.map((item: any) => item.id).join(',') : '0';
		// const filterIds = agentListFilter.length ? agentListFilter.map((item: any) => item.id).join(',') : '0';
		getTableData(filterIds);
		intervalRef.current = setInterval(() => getTableData(filterIds), WIDGET_REFRESH_INTERVAL.AGENT_LIST);
		return () => {
			clearInterval(intervalRef.current);
		};
	}, [agentListFilter, thresholdItems, additionalFilters]);

	// const groupColumns = (rowData: any, column: any) => {
	// 	return rowData.reduce((acc: any, value: any) => {
	// 		(acc[value[column.id]] = acc[value[column.id]] || []).push(value);
	// 		return acc;
	// 	}, {});
	// };

	React.useEffect(() => {
		let groupedData = {};
		if (groupingColumns.length > 0) {
			for (const data of filteredRowData) {
				groupingColumns
					.reduce((groupAcc: any, column: any, groupIdx: number) => {
						const key = data[column.id] || '';
						groupAcc[key] = groupAcc[key] || (groupIdx === groupingColumns.length - 1 ? [] : {});
						return groupAcc[key];
					}, groupedData)
					.push(data);
			}
		}
		setGroupedData(groupedData);
	}, [groupingColumns, filteredRowData]);

	const filterItems = agentListFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	const handleOnEventsPopoverClose = () => {
		setElRefPoint(null);
		setSelectedAgent(null);
		setIsEventsPopoverOpen(false);
	};

	const formatAMPM = (date: Date) => {
		if (date) {
			var hours = date.getHours();
			var minutes: any = date.getMinutes();
			var ampm = hours >= 12 ? 'PM' : 'AM';
			hours = hours % 12;
			hours = hours ? hours : 12; // the hour '0' should be '12'
			minutes = minutes < 10 ? '0' + minutes : minutes;
			var strTime = hours + ':' + minutes + ' ' + ampm;
			return strTime;
		} else {
			return '';
		}
	};

	const getTimeDifferenceInString = (higherDate: string, lowerDate: string) => {
		const seconds = (new Date(higherDate).getTime() - new Date(lowerDate).getTime()) / 1000;
		if (!isNaN(seconds)) {
			if (seconds > 60) {
				const minutes = seconds / 60;
				if (minutes > 60) {
					const hours = minutes / 60;
					return `${hours.toFixed(1)} Hrs`;
				} else {
					return `${Math.floor(minutes)} Mins`;
				}
			} else {
				return `${seconds} Secs`;
			}
		} else {
			return '';
		}
	};

	const getColorByAgentEvent = (event: string) => {
		return event.toLowerCase() === 'calling'
			? 'yellow'
			: event.toLowerCase() === 'aux'
				? 'green'
				: event.toLowerCase() === 'release'
					? 'red'
					: event.toLowerCase() === 'idle'
						? 'orange'
						: event.toLowerCase() === 'incall'
							? 'lightgreen'
							: '';
	};

	const getEventsPopoverContent = () => {
		return (
			<Box sx={{ p: 2 }} className={classes.popoverContent}>
				<div>
					<h3>{selectedAgent?.AgentName}</h3>
					<Stack direction={'column'} gap={1}>
						{selectedAgentEventDetails?.map((item: any, idx: number) => (
							<Box key={idx} display={'flex'} justifyContent="space-between" alignItems="center">
								<Box display={'flex'} gap={1}>
									{
										<Box
											sx={{
												background: getColorByAgentEvent(item.Event),
												width: '2px',
												height: '2rem',
												borderRadius: '4px'
											}}
										></Box>
									}
									<Box sx={{ display: 'flex', flexDirection: 'column' }}>
										<Stack direction={'row'} gap={5}>
											<Typography
												sx={{
													minWidth: '5rem',
													fontWeight: '500',
													fontSize: '12px',
													color: 'rgba(33, 33, 33, 0.7)'
												}}
											>
												{item.Event.toUpperCase()}
											</Typography>

											{item?.StartTime && item?.EndTime && (
												<Box
													sx={{
														display: 'flex',
														flexDirection: 'row',
														alignItems: 'center',
														gap: '5px',
														fontWeight: '400',
														fontSize: '12px',
														color: '#99A0A8'
													}}
												>
													<AccessTime sx={{ color: 'inherit', fontSize: '18px' }} />

													<Typography sx={{ color: 'inherit', fontSize: 'inherit' }}>{getTimeDifferenceInString(item?.EndTime, item?.StartTime)}</Typography>
												</Box>
											)}
										</Stack>
										<Typography
											sx={{
												fontWeight: '400',
												fontSize: '12px',
												color: '#99A0A8'
											}}
										>
											{formatAMPM(new Date(item?.StartTime))}
										</Typography>
									</Box>
								</Box>
							</Box>
						))}
					</Stack>
				</div>
			</Box>
		);
	};

	const getTableRows = (data: any) => {
		return (
			<>
				{data.map((row: any, rowIdx: number) => {
					return (
						<StyledTableRow hover role="checkbox" tabIndex={-1} key={row.SNO}>
							{groupingColumns.map((groupName: any, idx: number) => {
								return <StyledTableCell key={groupName + idx} align="left"></StyledTableCell>;
							})}
							{selectedColumns.map((column: any) => {
								const value: any = row[column.id];
								if (column.id === 'agentAction') {
									return (
										<StyledTableCell key={column.id + rowIdx} align={column.align}>
											<span className="icon-row">
												<span className="icon-col-sm">
													<IconButton disableRipple onClick={(event) => agentDetails(event, row)}>
														<img src={`${process.env.PUBLIC_URL}/icons/table-info-icon.svg`} width="20" alt="Info"></img>
													</IconButton>
												</span>
												<span className="icon-col-sm">
													<IconButton disableRipple onClick={(event) => agentEvents(event, row)}>
														<img src={`${process.env.PUBLIC_URL}/icons/table-graph-icon.svg`} width="20" alt="Graph"></img>
													</IconButton>
												</span>
											</span>
										</StyledTableCell>
									);
								} else if (column.id === 'AgentState') {
									return (
										<StyledTableCell key={column.id + rowIdx} align={'center'} width={column.width}>
											{row?.PauseReason ?
												<>
													<span className={STATUS_CLASS_MAP['PAUSED']}>{value}</span>
												</>
												:
												<>
													<span className={STATUS_CLASS_MAP[value]}>{value}</span>
												</>
											}
										</StyledTableCell>
									);
								} else if (column.id === 'Details') {
									return (
										<StyledTableCell key={column.id + rowIdx} align={'center'} width={column.width}>
											<DetailsIconButton color="primary" onClick={() => agentDetailsDrawer(row)}>
												<ArrowRightAltIcon sx={{ fontSize: '20px' }} />
											</DetailsIconButton>
										</StyledTableCell>
									);
								}
								// else if (column.id === 'Since') {
								// 	return (
								// 		<StyledTableCell
								// 			key={column.id + rowIdx}
								// 			align={'center'}
								// 			style={
								// 				{
								// 					// backgroundColor: minutes > 6 ? '#F2C2C2' : 'unset'
								// 				}
								// 			}
								// 			width={column.width}
								// 		>
								// 			{value}
								// 		</StyledTableCell>
								// 	);
								// }
								else {
									return (
										<StyledTableCell
											key={column.id + rowIdx}
											align={column.align}
											width={column.width}
											sx={{
												maxWidth: column.width
											}}
											className={`${row[column.id]?.warning || ''}`}
										>
											{(column.type === 'MIN_SEC' && secondsToMinSec(row[column.id]?.value || row[column.id])) ||
												(column.type === 'TIME' && secondsToTime(row[column.id]?.value || row[column.id])) ||
												value}
										</StyledTableCell>
									);
								}
							})}
						</StyledTableRow>
					);
				})}
			</>
		);
	};

	const handleOnSearch = (event: any) => {
		const searchText = event.target.value.length ? event.target.value.toLowerCase() : '';
		setSearchText(searchText);
		if (searchTextRef) {
			searchTextRef.current = searchText;
		}
		if (searchKeyRef) {
			searchKeyRef.current = searchSelect?.key || '';
		}
		// setSearchTextForAgentID(event.target.value.length ? event.target.value : '');
		if (searchText?.length) {
			let filteredRows: any = [];
			filteredRows = filterRowsBySearch({ rows: rowData, searchKey: searchSelect.key, searchText });
			// const filteredRows = rowData.filter((item: any) => item.AgentName.toLowerCase().includes(searchText));
			setFilteredRowData(filteredRows);
		} else {
			setFilteredRowData(rowData);
		}
	};

	React.useEffect(() => {
		handleOnSearch({ target: { value: searchText } });
	}, [searchSelect?.key]);

	const toggleThresholdDrawer = (isOpen: boolean, data: any = null, showSkillList: any = false) => {
		setIsThresholdDrawerOpen(isOpen);
		if (data) {
			const savedThresholdList = structuredClone(data);
			setSavedThresholdList((prev: any) => ({
				showSkillList: showSkillList,
				thresholdList: savedThresholdList
			}));
			if (props?.handleThresholdChange) {
				props.handleThresholdChange?.(savedThresholdList, showSkillList, props?.widgetId);
			}
			setThresholdItems(data);
		}
	};

	function getHoldStatus(holdDuration: number) {
		if (holdDuration && typeof holdDuration === 'number' && holdDuration > 0) {
			return 'Hold'
		} else {
			return 'Non-Hold'
		}
	}

	function getRowData(row: any) {
		row = row?.map((item: any) => {
			let rowObj = {
				...item,
				SkillsFormatted: item?.AgentSkills ? item?.AgentSkills : item?.AgentSkills,
				GroupsFormatted: item?.AgentGroups ? item?.AgentGroups : item?.AgentGroups,
				Since: secondsToTime(item?.Since),
				HoldDuration: secondsToTime(item?.HoldDuration),
				HoldStatus: getHoldStatus(item?.HoldDuration || 0),
				// CampaignNameOfLastCall: item?.CampaignNameOfLastCall ? item?.CampaignNameOfLastCall : "",
			};
			return rowObj;
		});
		return row;
	}


	const AgentListHeaderContent = () => {
		return (
			<TableRow>
				{groupingColumns.map((groupName: any, idx: number) => {
					return <StyledTableCell key={groupName + idx} align="left"></StyledTableCell>;
				})}
				{selectedColumns.map((column: any, idx: any) => {
					if (column.draggable) {
						return (
							<StyledTableCell
								key={column.id + idx}
								className="draggable-table-cell"
								align={'left'}
								draggable={true}
								sx={{
									minWidth: column.minWidth,
									whiteSpace: 'nowrap',
									cursor: 'pointer'
									// maxWidth: column.width
								}}
								onClick={() => handleSort(column.id)}
								onDragStart={(event) =>
									handleDragStart(event, {
										label: column.label,
										id: getColumnId(column)
									})
								}
							>
								<Typography display={'flex'} alignItems={'center'} fontSize={'12px'}>
									<span style={{ padding: '0 0.2rem', paddingTop: 4 }}>
										<DragIcon />
									</span>
									{column.label}
									{getSortIcon(column.id)}
								</Typography>
							</StyledTableCell>
						);
					} else if (column.id === 'hamburger') {
						return (
							<StyledTableCell
								key={column.id + idx}
								style={{
									minWidth: column.minWidth,
									textAlign: 'center'
								}}
							>
								<IconButton onClick={onHamburgerClick}>
									<img src={`${process.env.PUBLIC_URL}/icons/table-hamburger-icon.svg`} width="20" alt="Hamburger" style={{ marginTop: '5px' }}></img>
								</IconButton>
							</StyledTableCell>
						);
					} else {
						return (
							<StyledTableCell
								key={column.id + idx}
								align={column.align}
								onClick={() => handleSort(column.id)}
								style={{
									minWidth: column.minWidth,
									whiteSpace: 'nowrap',
									cursor: 'pointer'
									// maxWidth: column.width
								}}
							>
								{column.label}
								{getSortIcon(column.id)}
							</StyledTableCell>
						);
					}
				})}
			</TableRow>
		)
	}

	let finalTableData: any = []
	const getAgentListTableData = () => {
		if (groupingColumns.length) {
			finalTableData = []
			// Sort the grouped data by group names when sorting by grouped columns
			const sortedGroupedData = sortGroupedData(groupedData, groupingColumns);
			getFinalRows(sortedGroupedData, 0);
			return finalTableData;
		} else {
			return sortData(filteredRowData);
		}
	}

	const getFinalRows: any = (data: any, index: number) => {
		if (!Array.isArray(data)) {
			return Object.entries(data).map(([groupName, groupRowData]) => {
				const extraCell: any = {}
				for (let i = 0; i < index; i++) {

					extraCell['extraCell' + i] = ""

				}
				let groupRowDataLength = Array.isArray(groupRowData) ? groupRowData?.length : getLengthOfProps(groupRowData);
				extraCell['groupRowDataCount'] = groupRowDataLength;
				extraCell['index'] = index
				extraCell['groupName'] = groupName;
				finalTableData.push(extraCell);
				getFinalRows(groupRowData, index + 1)
			})

		} else {
			finalTableData = getSortedGroupData(data, finalTableData);
		}
	}

	const getAgentState = (row: any, value: any) => {
		const holdDuration = row?.HoldDuration
		const extraMark = (((typeof holdDuration === 'object' ? holdDuration?.value : holdDuration) > 0) && value === 'BUSY') ? <PauseCircleIcon sx={{ color: 'red', position: 'absolute', top: -4, right: -9, fontSize: '14px' }} /> : ""
		return row?.PauseReason ?
			<span
				title={value}
				style={{
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					display: 'inline-block',
					maxWidth: ' 100px',
				}}
				className={STATUS_CLASS_MAP['PAUSED']}>{value}</span>
			:
			<span className={STATUS_CLASS_MAP[value]} style={{ position: 'relative' }}>{value}{extraMark}</span>
	}

	function rowContent(_index: number, row: any) {
		let rowIdx = _index
		if (row.hasOwnProperty('groupName')) {
		}
		const keys = Object.keys(row);
		const indexxx = keys.indexOf('groupName');
		let colorr = getLevelColor(indexxx - 1);

		return (
			(row.hasOwnProperty('groupName')) ?
				<React.Fragment>
					{keys.map((key, i) => {
						if (key === 'groupName') {
							return <TableCell colSpan={selectedColumns.length + groupingColumns.length} sx={{ padding: '5px 16px', background: colorr }}>
								{row.groupName} {`${row.groupRowDataCount > 0 ? `(${row.groupRowDataCount})` : ''}`}
							</TableCell>
						} if (key.includes('extraCell')) {
							return <StyledTableCell key={key} sx={{ background: colorr }}>
								{''}
							</StyledTableCell>
						}
					})}
				</React.Fragment >
				:

				<React.Fragment>
					{/* <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.SNO}> */}
					{groupingColumns.map((groupName: any, idx: number) => {
						return <StyledTableCell key={groupName + idx} align="left"></StyledTableCell>;
					})}
					{selectedColumns.map((column: any) => {
						const value: any = row[column.id];
						if (column.id === 'agentAction') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={column.align}>
									<span className="icon-row">
										<span className="icon-col-sm">
											<IconButton disableRipple onClick={(event) => agentDetails(event, row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-info-icon.svg`} width="20" alt="Info"></img>
											</IconButton>
										</span>
										<span className="icon-col-sm">
											<IconButton disableRipple onClick={(event) => agentEvents(event, row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-graph-icon.svg`} width="20" alt="Graph"></img>
											</IconButton>
										</span>
									</span>
								</StyledTableCell>
							);
						} else if (column.id === 'AgentState') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={'center'} width={column.width}>
									{getAgentState(row, value)}
								</StyledTableCell>
							);
						} else if (column.id === 'Details') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={'center'} width={column.width}>
									<DetailsIconButton color="primary" onClick={() => agentDetailsDrawer(row)}>
										<ArrowRightAltIcon sx={{ fontSize: '20px' }} />
									</DetailsIconButton>
								</StyledTableCell>
							);
						} else if (column.id === 'hamburger') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={'center'}>
									{value === 'expand' && (
										<span className="icon-row">
											<span className="icon-col">
												<img src={`${process.env.PUBLIC_URL}/icons/table-expand-icon.svg`} width="10" alt="Expand"></img>
											</span>
										</span>
									)}
								</StyledTableCell>
							);
						}
						// else if (column.id === 'Since') {
						// 	return (
						// 		<StyledTableCell
						// 			key={column.id + rowIdx}
						// 			align={'center'}
						// 			style={
						// 				{
						// 					// backgroundColor: minutes > 6 ? '#F2C2C2' : 'unset'
						// 				}
						// 			}
						// 			width={column.width}
						// 		>
						// 			{value}
						// 		</StyledTableCell>
						// 	);
						// }
						else {
							return (
								<StyledTableCell
									key={column.id + rowIdx}
									align={column.align}
									width={column.width}
									title={typeof value === 'object' ? '' : value}
									sx={{
										minWidth: column.minWidth,
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										maxWidth: '190px',
										// maxWidth: column.width
									}}
									className={`${row[column.id]?.warning || ''}`}
								>
									{(column.type === 'MIN_SEC' && secondsToMinSec(row[column.id]?.value || row[column.id])) ||
										(column.type === 'TIME' && secondsToTime(row[column.id]?.value || row[column.id])) ||
										value}
								</StyledTableCell>
							);
						}
					})}
					{/* </StyledTableRow> */}
				</React.Fragment>
		);
	}


	const getTableStyle = () => {
		let height = 54;
		if (agentListFilter.length > 0 || additionalFiltersLength > 0) {
			height += 14;
		}
		return `calc(100% - ${height}px)`;
	}

	const handleSelectSearchField = (type: any = null) => {
		if (type) {
			setSearchSelect(type);
			if (searchKeyRef) {
				searchKeyRef.current = type?.key || '';
			}
		}
		setSearchFieldMenuAnchorEl(null);
	};

	const handleSearchFieldMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		if (event.currentTarget) setSearchFieldMenuAnchorEl(event.currentTarget);
	};

	const searchFields: any = [
		{ name: 'Agent Id', key: 'AgentId' },
		{ name: 'Agent Name', key: 'AgentName' },
		{ name: 'Campaign', key: 'CampaignNameOfLastCall' },
		// { name: 'Skills', key: 'SkillsFormatted' },
		{ name: 'Skills', key: 'AgentSkills' },
	];


	const additionalFiltersList = () => {
		try {
			return Object.keys(additionalFilters).map((key: any) => {
				if (additionalFilters[key]?.length === 0) return null;
				return additionalFilters[key].map((item: any, index: number) => (
					<Chip
						key={index}
						label={`${key.toUpperCase()} - ${item}`}
						color="primary"
						variant="outlined"
						onDelete={() => {
							setAdditionalFilters((prev: any) => {
								let newFilters = { ...prev };
								newFilters[key] = newFilters[key]?.filter((_: any) => _ !== item);
								props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(newFilters), '', '', false, { data: selectedColumns });
								return newFilters;
							});
						}}
						deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
				))
			})
		} catch (e) {
			console.log("error", e)
		}
	}

	return (
		<Card className={!moreData ? "changedCustomCard" : resized ? "changedCustomCard" : "customCard"} ref={tableContainerRef}>
			<div className="card-header">
				<div className="card-title">
					Agent List V2 <div className="card-title-badge">Live</div> {loadingRef.current && <CircularProgress size={10} />}
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<Grid container style={{ border: '1px solid #D6D6D7', borderRadius: '8px 0px 0px 8px', backgroundColor: '#F2F2F2', width: '125px', marginRight: '18rem' }}>
						<Grid item sx={{ display: 'flex' }}>
							<div style={{ flexGrow: 1, minWidth: '100px' }} onClick={handleSearchFieldMenuOpen}>
								<Typography
									variant="caption"
									sx={{
										fontWeight: 400,
										fontSize: '12px',
										textAlign: 'right',
										color: '#212121',
										cursor: 'pointer',
										paddingLeft: '15px',
									}}
								>
									{searchSelect.name}
								</Typography>
							</div>
							<Menu
								sx={{ width: '50px' }}
								anchorEl={searchFieldMenuAnchorEl}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								open={labelOpen}
								onClose={() => handleSelectSearchField()}
								PaperProps={{ className: classes.dropdownMenu }}
								container={fullscreenContainer}
							>
								{searchFields?.map((eachField: any, idx: any) => {
									return (
										<MenuItem key={idx} className={classes.dropdownLabelMenuItem} onClick={() => handleSelectSearchField(eachField)}>
											{eachField.name}
										</MenuItem>
									);
								})}
							</Menu>
							<KeyboardArrowDownOutlinedIcon style={{ color: '#536580', fontSize: '10px', marginRight: '13px', marginTop: 10 }} />
							<WidgetSearch widget onTextChange={handleOnSearch}></WidgetSearch>
						</Grid>
					</Grid>
					{/* <WidgetSearch onTextChange={handleOnSearch}></WidgetSearch> */}
					<WidgetDownload fullscreenContainer={fullscreenContainer} element={tableDataRef} xlsx rowData={getRowData(rowData)} columns={selectedColumns} name={'Agent List V2'}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={agentListFilter.length + additionalFiltersLength} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
					<div onClick={() => toggleThresholdDrawer(true, null)}>
						<WidgetGraph></WidgetGraph>
					</div>
				</div>
			</div>
			<FilterDrawer
				isOpen={isDrawerOpen}
				toggleDrawer={toggleDrawer}
				applyFilters={handleApplyFilters}
				existingSelectedFilters={agentListFilter}
				setResponseLength={setresponseLength}
				allowedFilters={allowedFilters}
				existingFilterCategory={filterType}
				applyFilterOnExistingData={handleFilterExistingData}
				showAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? ['state', 'mode'] : []}
				initialAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? additionalFilters : { state: [], mode: [] }}
				disableCampaignGroupSelection={true}
				fullscreenContainer={fullscreenContainer}
			/>
			{/* <FilterDrawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} existingSelectedFilters={agentListFilter} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData}/> */}
			<Box sx={{ pt: 2, pl: 2 }}>
				{(agentListFilter.length > 0 || additionalFiltersLength > 0) && (
					<div className="filter-outer">
						<div className="filter-container">
							<Stack direction="row" spacing={1}>
								{agentListFilter.length > 0 && filterItems}
								{additionalFiltersLength > 0 && additionalFiltersList()}
							</Stack>
						</div>
						<div className="filter-remove" onClick={clearFilter}>
							Remove
						</div>
					</div>
				)}
			</Box>
			<div className="search-drag-drop" onDrop={handleOnDrop} onDragOver={(e) => e.preventDefault()}>
				{groupingColumns.length > 0 && (
					<Box className={classes.dragdropItemsWrapper}>
						<div className="filter-outer">
							<div className="filter-container">
								<Stack direction="row" spacing={1}>
									{groupingColumns.map((item: any, index: number) => (
										<Chip
											key={index}
											label={item.label}
											color="primary"
											variant="outlined"
											onDelete={() => {
												setGroupingColumns((prev: any) => {
													let grpCol = prev.filter((_: any) => _.id !== item.id);
													saveDataToDashboard('groupingColumns', grpCol);
													return grpCol;
												});
											}}
											deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />}
										/>
									))}
								</Stack>
							</div>
							<div className="filter-remove" onClick={() => {
								setGroupingColumns([]);
								saveDataToDashboard('groupingColumns', []);
							}}>
								Remove
							</div>
						</div>
					</Box>
				)}
				<Typography
					component={'span'}
					color="#99A0A8"
					position="absolute"
					// top={'50'}
					// left={'50'}
					fontSize={'12px'}
				>
					{groupingColumns.length < 3 && 'Drag and drop the metrics for grouping '}
					{/* <span>
						(Currently you don’t have any metrics which can be grouped)
					</span> */}
				</Typography>
			</div>
			{/* <Paper sx={{ width: '100%', overflow: 'hidden' }} className='custom-table-paper-height'> */}
			<Paper sx={{
				width: '100%', overflow: 'hidden',
				height: getTableStyle(),
			}}>
				{/* <TableContainer className="custom-table-scroll custom-table-maxHeight" ref={downloadContent} > */}
				{/* <Table stickyHeader aria-label="sticky table"> */}
				<AgentListVTable
					tableDataRef={tableDataRef}
					HeaderContent={AgentListHeaderContent}
					rowContent={rowContent}
					data={getAgentListTableData()}
				/>
			</Paper>
			<Popover
				open={isPopoverOpen}
				onClose={handleOnPopoverClose}
				anchorReference="anchorPosition"
				anchorPosition={eleRefPoint}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				container={fullscreenContainer}
			>
				{getPopoverContent()}
			</Popover>
			<Popover
				open={isEventsPopoverOpen}
				onClose={handleOnEventsPopoverClose}
				anchorReference="anchorPosition"
				anchorPosition={eleRefPoint}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				container={fullscreenContainer}
			>
				{getEventsPopoverContent()}
			</Popover>
			<BargeInDrawer isOpen={isBargeInOpen} toggleDrawer={toggleBargeInDrawer} agentDetails={selectedAgent} />
			<AgentDetailsDrawer fullscreenContainer={fullscreenContainer} isOpen={isAgentDetailsDrawerOpen} toggleDrawer={toggleAgentDetailsDrawer} selectedAgent={selectedAgent} agentDetails={drawerDetails} />
			<ThresholdDrawer
				isOpen={isThresholdDrawerOpen}
				title={'Set'}
				toggleDrawer={toggleThresholdDrawer}
				thresholdItems={thresholdItems}
				savedThresholdList={savedThresholdList?.thresholdList || []}
				showSkillListByDefault={savedThresholdList.showSkillList}
				container={fullscreenContainer}
			/>
			<SelectPopover
				isOpen={isColumnsPopoverOpen}
				elementsArray={columns}
				anchorRef={columnsEleRefPoint}
				handlePopoverClose={handleOnColumnsPopoverClose}
				selectedElements={selectedColumns}
				handleOnSelectionChange={handleOnSelectColumnChange}
			/>
		</Card>
	);
}
